var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("../../../assets/img/common/icon.png"),"alt":""}}),_c('h3',[_vm._v("信安天途")])])
}]

export { render, staticRenderFns }